// UTM Tracking utility - Critical for Google Ads conversion tracking

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
const STORAGE_KEY = 'utm_params';

/**
 * Capture UTM parameters from URL and store in localStorage
 * Called on page load
 */
export const captureUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmData = {};
  let hasUTMParams = false;

  UTM_PARAMS.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      utmData[param] = value;
      hasUTMParams = true;
    }
  });

  // Only store if we found at least one UTM parameter
  if (hasUTMParams) {
    const existingData = getStoredUTMParams();
    const updatedData = { ...existingData, ...utmData };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedData));
    console.log('UTM params captured:', updatedData);
  }
};

/**
 * Get stored UTM parameters from localStorage
 * @returns {Object} UTM parameters object
 */
export const getStoredUTMParams = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error reading UTM params:', error);
    return {};
  }
};

/**
 * Get all UTM parameters with defaults
 * @returns {Object} Complete UTM object with empty strings for missing values
 */
export const getUTMParamsForSubmission = () => {
  const stored = getStoredUTMParams();
  const utmObject = {};
  
  UTM_PARAMS.forEach(param => {
    utmObject[param] = stored[param] || '';
  });

  return utmObject;
};

/**
 * Clear stored UTM parameters
 */
export const clearUTMParams = () => {
  localStorage.removeItem(STORAGE_KEY);
};

/**
 * Initialize UTM tracking on app load
 */
export const initUTMTracking = () => {
  captureUTMParams();
  
  // Also capture on navigation within SPA
  window.addEventListener('popstate', captureUTMParams);
};
